<template>
  <div style="background-color: #fff; padding: 15px; box-sizing: border-box">
    <el-row :gutter="10" style="margin-bottom: 20px; min-height: 114px">
      <el-col :span="4" v-for="(item, index) in typeList" :key="index">
        <div
          class="box fontCenter"
          :class="{ 'box-color': index == activeName }"
          @click.capture="clickHandle(index, item.orderName)"
          style="flex-direction: column"
        >
          <div class="type">{{ item.orderName }}</div>
          <div class="numberStyle"
            ><div
              class="numberBorder"
              @click="groupType == 'wm' ? tabClick('02', index, item.orderName) : ''"
            >
              <span style="font-size: 30px; color: #81d3f8; line-height: 35px">{{
                item.orderNumber ? item.orderNumber : 0
              }}</span>
              <div>进行中</div>
            </div>
            <div> </div>
            <div
              class="numberBorder"
              @click="groupType == 'wm' ? tabClick('03', index, item.orderName) : ''"
            >
              <span style="font-size: 30px; color: #81d3f8; line-height: 35px">{{
                item.orderApprovingNumber ? item.orderApprovingNumber : 0
              }}</span>
              <div>待审批</div>
            </div>
          </div>
        </div>
      </el-col>
    </el-row>
    <el-tabs
      v-model="activeTab"
      class="addCooperationTabs"
      type="border-card"
      @tab-click="tabClick(activeTab)"
    >
      <!-- tab -->
      <el-tab-pane label="进行中" name="02">
        <OngoingTable
          ref="onGoingTableRef"
          :columnList="onGogingcolumnList"
          :orderName="orderName"
          :indexType="groupType"
          :activeTab="activeTab"
          @cancel="cancel"
          @openLoading="openLoading"
        ></OngoingTable>
      </el-tab-pane>
      <el-tab-pane label="待审批" name="03">
        <ApprovalTable
          ref="approvalTableRef"
          :columnList="approvalColumnList"
          :orderName="orderName"
          :activeTab="activeTab"
          :indexType="groupType"
          @cancel="cancel"
          @openLoading="openLoading"
        ></ApprovalTable>
      </el-tab-pane>
      <el-tab-pane
        label="即将到期的合同"
        name="third"
        v-if="['租赁合同', '客方合同', '供方合同', '物业合同'].includes(orderName)"
        :orderName="orderName"
        :activeTab="activeTab"
        :indexType="groupType"
      >
        <BeingOverdue
          v-if="['租赁合同', '物业合同'].includes(orderName)"
          ref="bejingOverdueRef"
          :orderName="orderName"
          :activeTab="activeTab"
          :indexType="groupType"
          @cancel="cancel"
          @openLoading="openLoading"
        ></BeingOverdue>
        <DslyBeingOverdue
          v-else
          ref="dslyBejingOverdueRef"
          :orderName="orderName"
          :activeTab="activeTab"
          :indexType="groupType"
          @cancel="cancel"
          @openLoading="openLoading"
        ></DslyBeingOverdue>
      </el-tab-pane>
    </el-tabs>
  </div>
</template>

<script>
  import OngoingTable from './components/OngoingTable.vue';
  import ApprovalTable from './components/ApprovalTable.vue';
  import XEUtils from 'xe-utils/methods/xe-utils';
  // import Overdue from './components/Overdue.vue';
  import {
    tableTitleMap,
    multimodalTransportTableTitleMap,
    chengkuangTableTitleMap,
    wumaoTableTitleMap,
  } from './data.js';
  import BeingOverdue from './components/BeingOverdue.vue';
  import DslyBeingOverdue from './components/dslyBeingOverdue.vue';
  import jumpDetailMixin from './mixins/jumpDetailMixin.js';
  import API from '@/api/homepage/homepage.js';
  import BASE_API from '@/api/dataBase.js';

  // import loading from '@/common/js/load.js';
  export default {
    name: 'billPage',
    props: ['indexType'],
    mixins: [jumpDetailMixin],
    data() {
      return {
        activeName: '0',
        activeTab: '02',
        orderName: '',
        onGogingcolumnList: [], //进行中
        approvalColumnList: [], //审批中
        onGogingTableData: [''],
        approvalTableData: [],
        typeList: [],
        groupType: '',
        // loading: false,
      };
    },
    mounted() {
      this.openLoading();
      // setTimeout(() => {
      //   this.businessGroup = this.userInfo.businessGroup;
      //   // this.getOrderTypeName();
      //   // this.getMontuedData();
      // }, 2000);
    },
    methods: {
      // 在页面加载时，同步获取表格数据
      openLoading() {
        this.$emit('openLoading');
      },
      cancel() {
        this.$emit('cancel');
      },
      clickHandle(activeName, orderName) {
        console.log(activeName, orderName, this.orderName);
        if (this.orderName == orderName) {
          return;
        }
        this.activeName = activeName;
        this.orderName = orderName;
        // this.getColumn(orderName);
        console.log('点击单据类型', activeName, orderName);
        this.resetPage();
        // this.getTableData();
      },
      tabClick(val, activeName, orderName) {
        this.activeTab = val;
        if (activeName) this.activeName = activeName;
        // 从方块点击切换tab值，若业务板块改变，则根据组件监听获取数据，未改变通过getTableData获取数据
        if (orderName && this.orderName != orderName) {
          this.orderName = orderName;
        } else {
          console.log('点击切换tab', val, this.orderName, this.activeTab);
          this.getTableData(this.orderName);
          this.resetPage();
        }
      },

      // 获取当前登录人所在的部门
      async getDepartmentList() {
        const params = {
          id: this.userInfo.userCode,
          userCode: this.userInfo.userCode,
          personName: this.userInfo.userName,
        };
        const res = await this.$axios.post(BASE_API.GET_PERSON_API, params);
        let departList = [];
        if (res.data.code === 0) {
          (res.data.data.personDepartmentInfo || []).map((v) => {
            departList.push(v.personDepartmentCode);
          });
        } else {
          departList = [];
        }
        console.log(departList, 'departList');
        return departList || [];
      },

      // 根据业务板块获取单据类型
      async getOrderTypeName() {
        console.log(
          '公司编号',
          this.userInfo,
          this.userInfo.companyCode,
          this.userInfo.departmentCode
        );
        const postData = {
          companyCode: this.userInfo.companyCode,
          // departmentCode: this.userInfo.departmentCode,
          plateName: this.groupType,
          // companyName: this.userInfo.companyName,
          businessGroup: this.userInfo.businessGroup,
          pageSize: 10,
          pageNum: 1,
          adminFlag: '2',
          departmentCodeList: await this.getDepartmentList(),

          // requestStatus: '02',
        };
        let { data } = await this.$axios.post(API.get_order_typeName, postData);
        // this.cancel()
        if (data.code == 0) {
          let type = data.data;
          let typeList = [];
          for (let key in type) {
            typeList.push(type[key]);
          }
          this.typeList = typeList;
          if (this.groupType == 'wm') {
            const list = [];
            const nameList = this.typeList.map((v) => v.orderName);
            const defaultNameList = [
              '合作伙伴',
              '商品主数据',
              '仓库主数据',
              '立项',
              '采购合同',
              '销售合同',
              '销售协议',
              '双边合同',
              '服务合同',
              '应付结算',
              '应收结算',
              '销售开票申请',
            ];
            const setNameList = Array.from(new Set([...defaultNameList, ...nameList]));
            for (let i = 0; i < setNameList.length; i++) {
              const name = setNameList[i];
              const item = typeList.find((v) => v.orderName === name);
              if (item) list.push(item);
            }
            this.typeList = list;
          }
          this.orderName = this.typeList[0]?.orderName;
          this.getTableData();
          console.log('单据类型', this.typeList, data);
        } else {
          this.cancel();
          this.$message.error('单据类型获取失败');
        }
      },
      // 根据单据类型获取表格数据
      getTableData(orderName) {
        console.log('获取表格中的activeTable', this.activeTab);
        if (this.activeTab == '02') {
          // 获取进行中的表格数据
          // console.log(this.orderName, 'orderName');
          this.$refs.onGoingTableRef.getTableData(orderName);
        } else if (this.activeTab == '03') {
          // 获取审批中的表格数据
          this.$refs.approvalTableRef.getTableData(orderName);
        } else {
          // 获取即将到期的表格数据
          if (orderName == '租赁合同' || orderName == '物业合同') {
            this.$refs.bejingOverdueRef.getTableData(orderName);
          } else {
            this.$refs.dslyBejingOverdueRef.getTableData(orderName);
          }
        }
      },
      // 根据单据类型获取表头
      getColumn(orderName) {
        if (['园区', '仓储', '仓单'].includes(this.businessGroup)) {
          this.onGogingcolumnList = tableTitleMap[orderName]?.onGoingColumn;
          this.approvalColumnList = tableTitleMap[orderName]?.approvalColumn;
        } else if (this.businessGroup == '多式联运') {
          this.onGogingcolumnList = multimodalTransportTableTitleMap[orderName]?.onGoingColumn;
          this.approvalColumnList = multimodalTransportTableTitleMap[orderName]?.approvalColumn;
        } else if (this.businessGroup == '城矿') {
          this.onGogingcolumnList = chengkuangTableTitleMap[orderName]?.onGoingColumn;
          this.approvalColumnList = chengkuangTableTitleMap[orderName]?.approvalColumn;
        } else if (this.businessGroup == '物贸') {
          this.onGogingcolumnList = wumaoTableTitleMap[orderName]?.onGoingColumn;
          this.approvalColumnList = wumaoTableTitleMap[orderName]?.approvalColumn;
        }
      },
      setGroupTypeData(val) {
        this.groupType = val;
      },
    },
    watch: {
      indexType: {
        handler(val) {
          if (val) {
            this.groupType = val;
            this.activeTab = '02';
            setTimeout(() => {
              this.setGroupTypeData(val);
              this.businessGroup = this.userInfo.businessGroup;
              this.getOrderTypeName();
              // this.getMontuedData();
            }, 2000);
            // this.getOrderTypeName();
          } else {
            this.cancel();
          }
        },
        immediate: true,
        deep: true,
      },
      userInfo: {
        handler: XEUtils.debounce(function () {
          this.businessGroup = this.userInfo.businessGroup;
          this.activeName = '0';
          this.getOrderTypeName();
        }, 1000),
        deep: true,
        // handler(val) {
        //   if (val) {
        //     console.log(val, 'userInfo监听');
        //     this.activeTab = '02';
        //     setTimeout(() => {
        //       this.businessGroup = this.userInfo.businessGroup;
        //       this.activeName = '0';
        //       this.getOrderTypeName();
        //       // this.getMontuedData();
        //     }, 2000);
        //     // this.getOrderTypeName();
        //   } else {
        //     this.cancel();
        //   }
        // },
        // immediate: true,
        // deep: true,
      },
    },
    components: {
      OngoingTable,
      ApprovalTable,
      BeingOverdue,
      DslyBeingOverdue,
      // Overdue,
    },
  };
</script>

<style lang="scss" scoped>
  .box {
    background-color: #ebf3fe;
    margin: 4px 0 10px 0;
    border-radius: 5px;
  }
  .box-color {
    background-color: #cdd9e6;
  }
  .two-box {
    margin-left: 10px;
  }
  .fontCenter {
    display: flex;
    justify-content: center;
    align-items: center;
    flex-direction: column;
    font-size: 14px;
    height: 100px;

    cursor: pointer;
  }
  .numberStyle {
    display: flex;
    padding: 0;
    width: 100%;
    height: 70%;
  }
  .type {
    width: 100%;
    padding: 0;
    // border: 1px solid grey;
    height: 30px;
    line-height: 30px;
    display: flex;
    justify-content: center;
    border-radius: 5px;
  }
  .numberBorder {
    display: flex;
    justify-content: center;
    align-items: center;
    border: 5px;
    flex-direction: column;
    font-size: 12px;
    width: 50%;
    &:first-child {
      border: 1px solid #ddd;
      border-left: 0;
      border-bottom: 0;
    }
    &:last-child {
      border-top: 1px solid #ddd;
    }
  }
  .box-color {
    .numberBorder {
      &:first-child {
        border: 1px solid #fff;
        border-left: 0;
        border-bottom: 0;
      }
      &:last-child {
        border-top: 1px solid #fff;
      }
    }
  }
</style>
